import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F5F0' }}>
      <nav className="bg-white border-b border-border shadow-sm">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <img src="/assets/logo.png" alt="contractcheck360" className="h-10 w-auto" />
              <span className="text-xl brand-name" style={{ color: '#1A4D2E' }}>contractcheck360</span>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-sm hover:underline" style={{ color: '#1A4D2E' }}>
              <ArrowLeft className="w-4 h-4" /> Volver al inicio
            </Link>
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-4 md:px-8 max-w-4xl py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Merriweather, serif', color: '#1A4D2E' }}>
          Términos y Condiciones
        </h1>
        <p className="text-sm mb-8" style={{ color: '#64748B' }}>Última actualización: Diciembre 2025</p>

        <div className="bg-white border border-border rounded-sm p-6 md:p-10 space-y-6" style={{ lineHeight: '1.8' }}>
          
          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>1. Aceptación de Términos</h2>
            <p>Al acceder y usar ContractCheck360 ("la Plataforma"), usted acepta estos Términos y Condiciones. Si no está de acuerdo, no utilice el servicio.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>2. Descripción del Servicio</h2>
            <p>ContractCheck360 es una plataforma que utiliza inteligencia artificial para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Analizar documentos contractuales cargados por el usuario.</li>
              <li>Extraer y resumir cláusulas relevantes.</li>
              <li>Identificar posibles riesgos contractuales.</li>
              <li>Comparar múltiples contratos.</li>
              <li>Generar reportes en PDF y Excel.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>3. Registro y Cuenta</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Debe proporcionar información veraz al registrarse.</li>
              <li>Es responsable de mantener la confidencialidad de su contraseña.</li>
              <li>Debe notificarnos inmediatamente sobre uso no autorizado de su cuenta.</li>
              <li>Un usuario puede tener solo una cuenta activa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>4. Uso del Servicio</h2>
            <p><strong>Usted se compromete a:</strong></p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Usar la Plataforma solo para fines legales.</li>
              <li>No cargar contenido ilegal, difamatorio o que infrinja derechos de terceros.</li>
              <li>No intentar acceder a sistemas o datos no autorizados.</li>
              <li>No usar el servicio para competir directamente con nosotros.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>5. Pagos y Facturación</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Los precios se muestran en Pesos Mexicanos (MXN) e incluyen IVA.</li>
              <li>El pago se procesa mediante Stripe antes de ejecutar el análisis.</li>
              <li>Los pagos no son reembolsables una vez procesado el análisis.</li>
              <li>Nos reservamos el derecho de modificar precios con previo aviso.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>6. Propiedad Intelectual</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>La Plataforma, su diseño, código y marca son propiedad de ContractCheck360.</li>
              <li>Usted conserva la propiedad de los documentos que carga.</li>
              <li>Nos otorga licencia limitada para procesar sus documentos con el fin de prestar el servicio.</li>
              <li>Los análisis generados son para su uso personal o empresarial, no para reventa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>7. Limitación de Responsabilidad</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>El análisis es generado por inteligencia artificial y tiene carácter informativo.</li>
              <li>No garantizamos exactitud, completitud ni idoneidad para decisiones específicas.</li>
              <li>No somos responsables por decisiones tomadas basándose en los análisis.</li>
              <li>Nuestra responsabilidad máxima se limita al monto pagado por el servicio específico.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>8. Confidencialidad</h2>
            <p>Nos comprometemos a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Tratar sus documentos de forma confidencial.</li>
              <li>No compartir sus documentos con terceros (excepto proveedores necesarios para el servicio).</li>
              <li>Eliminar sus documentos a solicitud, conforme al Aviso de Privacidad.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>9. Terminación</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Puede cancelar su cuenta en cualquier momento.</li>
              <li>Podemos suspender o cancelar cuentas que violen estos términos.</li>
              <li>Al terminar, perderá acceso a sus análisis almacenados.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>10. Modificaciones</h2>
            <p>Podemos modificar estos términos. Los cambios entrarán en vigor al publicarse. El uso continuado implica aceptación de las modificaciones.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>11. Ley Aplicable y Jurisdicción</h2>
            <p>Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Para controversias, las partes se someten a los tribunales competentes de la Ciudad de México, renunciando a cualquier otro fuero.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>12. Contacto</h2>
            <p>Para preguntas sobre estos términos:</p>
            <p className="mt-2"><strong>Email:</strong> legal@contractcheck360.com</p>
          </section>

          <div className="mt-8 p-4 rounded-sm" style={{ backgroundColor: '#FEF3C7', border: '1px solid #F59E0B' }}>
            <p className="text-sm" style={{ color: '#92400E' }}>
              <strong>Aviso importante:</strong> El servicio de ContractCheck360 es una herramienta de apoyo informativo. Los análisis generados por inteligencia artificial NO sustituyen el consejo de un abogado calificado. Para decisiones legales importantes, consulte siempre a un profesional del derecho.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
